export default {
	stage: process.env.REACT_APP_STAGE || '',
	api: process.env.REACT_APP_API_URL || '',
}